export class MemoPeriodicView
{
  public dayMonth: string;
  public dayWeek: string;
  public executeNow: boolean;
  public hour: string;
  public isEnabled: boolean;
  public minutes: string;
  public month: string;
  public seconds: string;
  public nextExecution?: Date;
  // Son solo variables de apoyo.
  public sNextExecution?: string;
  public sStatus: string;

  constructor()
  {
    // Valores por defecto.
    this.isEnabled = true;
  }
}
